<template>
  <v-dialog
    class="rounded-0 bg-white darken-2 "
    v-model="notify"
    max-width="550"
  >
  <div class="pa-4 " style="background-color: white;">
    <v-card   outlined >
      <v-toolbar height="78" :color="color" dark>{{ title }}</v-toolbar>
      <div v-if="this.model">
        <v-card-text>
          <div class="text-h6"><b># : </b>{{ this.model.id }}</div>
        </v-card-text>
        <v-card-text v-if="this.model.beneficiary_no">
          <div><b>beneficiary no :</b>{{ this.model.beneficiary_no }}</div>
        </v-card-text>
        <template v-if="this.model.pricing">
          <v-card-text v-if="this.model.pricing.units">
          <div><b>unite : </b>{{ this.model.pricing.units }}</div>
        </v-card-text>
        </template>
        
        <v-card-text v-if="this.model.customer_id">
          <div class="">
            <b>Customer : </b>
            <router-link
              target="_blank"
              :to="'/customer/' + this.model.customer_id"
              >{{ this.model.customer_id }}</router-link
            >
          </div>
        </v-card-text>
      </div>

      <v-card-actions class="justify-end">
        <v-btn color="blue darken-1" text @click="confirmDialog(true)"
          >Yes</v-btn
        >
        <v-btn color="red darken-1" text @click="confirmDialog(false)"
          >Cancel</v-btn
        >
      </v-card-actions>
    </v-card>
  </div>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    isPopup: {
      default: false,
    },
    color: {
      default: "black",
    },
    model: {
      default: [],
    },
    title: {
      default: "",
    },
    description: {
      default: "",
    },
  },
  computed: {
    ...mapGetters(["getForm"]),
    form() {
      return this.getForm;
    },
  },
  data() {
    return {
      notify: false,
    };
  },
  watch: {
    isPopup() {
      this.notify = true;
    },
  },
  methods: {
    confirmDialog(val) {
      if (val) {
        this.$emit("confirmDialog");
      }
      this.notify = false;
    },
  },
};
</script>
